const UPDATES = [
  {
    date: '07-28',
    title: '《暗夜追踪者》第128话更新，真相终于浮出水面',
    tag: '韩漫更新',
  },
  {
    date: '07-27',
    title: '国漫新作《星辰变》动画联动特别篇独家上线',
    tag: '国漫速递',
  },
  {
    date: '07-27',
    title: '日漫《异世界食堂》第三季确认制作，先导故事登陆本站',
    tag: '日漫资讯',
  },
  {
    date: '07-26',
    title: '香香漫画移动端阅读体验全面优化，加载速度提升50%',
    tag: '平台公告',
  },
  {
    date: '07-26',
    title: '热门韩漫《都市恋爱法则》连载突破200话纪念活动',
    tag: '韩漫更新',
  },
  {
    date: '07-25',
    title: '古风国漫专区正式上线，百年经典与新锐佳作齐聚',
    tag: '平台公告',
  },
  {
    date: '07-24',
    title: '悬疑题材漫画专题上线，烧脑剧本一次看个够',
    tag: '编辑推荐',
  },
  {
    date: '07-24',
    title: '下拉式追更功能获千万用户好评，阅读体验再升级',
    tag: '平台公告',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            近期快讯
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            最新漫画更新动态与平台资讯，追更不迷路
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200 space-y-0">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[29px] md:-left-[33px] top-0 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100" />
                <div className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5 ml-2">
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-800 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}